;( function( $, undefined )
{
    $.fn.ComposeMessages = function()
    {
        var $mainContainer = $( '#PDC6-main-container' );

        if( $mainContainer.hasClass( 'user-messages-compose' ) )
        {
            if( $( '.lia-form-field-error' ).size() )
            {
                $( '#pm-compose-error' ).removeClass( 'hide' );
            }

            var $l10n = $( '#pm-l10n' )
              , $form = $( '.MessageEditor .lia-form-input-wrapper' );

            var $subject = $( '.lia-form-to-users-input' ).attr( 'placeholder', $l10n.data( 'enter-psn' ) );
            $( '.lia-form-subject-input' ).attr( 'placeholder', $l10n.data( 'enter-subject' ) );

            if( $l10n.data( 'to' ) != '' )
            {
                $subject.val( $l10n.data( 'to' ) );
            }

            var $previewButton = $( '.lia-link-navigation.preview-link' )
              , $submitCancel  = $( '.lia-form-submit' ).find( '.lia-button-wrapper-Cancel-action' )
              , $previewClone  = $previewButton.clone().addClass( 'pdc6-button-black' )
              , $quoteButton   = $( '.lia-button.quote-message-link' )
              , $quoteClone    = $quoteButton.clone().addClass( 'pdc6-button-black' )

            $previewClone.click( function( e )
            {
                e && e.preventDefault();

                $( 'input[name="messageEditorTab_0"]' ).val( 'preview' );
                $( 'input[name="messageEditorTab_1"]' ).val( 'preview' );
                $( 'input[name="messageEditorTab_2"]' ).val( 'preview' );
                $( '.lia-button-Preview-action' ).trigger( 'click' );
            } );

            $( '.quote-link' ).click( function( e )
            {
                e && e.preventDefault();

                $quoteButton[ 0 ].click();
                $( 'html, body' ).animate( {
                    scrollTop : $form.offset().top
                }, 200 );
            } );

            $( '.lia-panel-message-content .lia-message-body-content' ).find( 'p' ).each( function()
            {
                var $this = $( this );

                if( $this.html().replace( /\s|&nbsp;/g, '' ).length == 0 )
                {
                    $this.remove();
                }
            } );

            $( '#pm-message-body' ).html( $( '.private-messages-content .lia-tabs-standard-wrapper > .lia-panel-message .lia-panel-message-content .lia-message-body-content' ).html() );

            var $previewDate = $( '.message-preview' ).find( '.lia-note-received-date-wrapper' ).eq( 0 );

            if( $previewDate.size() )
            {
                var $heading = $( '.message-preview' ).find( '.lia-message-heading' );

                $heading.prepend( $previewDate.clone() );
                $heading.prepend( '<h5 id="preview-title-separator">' + $l10n.data( 'preview' ) + '</h5>' );
                $previewDate.remove();
            }

            var $oldMessage      = $( '.lia-panel-message-content' )
              , $addToFavs       = $( '#add-user-favs' )
              , $ignoreUser      = $( '#ignore-this-user' )
              , addFriendLink    = $oldMessage.find( '.add-friend-link' ).attr( 'href' )
              , deleteFriendLink = $oldMessage.find( '.delete-friend-link' ).attr( 'href' )
              , ignoreUserLink   = $oldMessage.find( '.add-ignore-link' ).attr( 'href' )
              , removeIgnoreLink = $oldMessage.find( '.delete-ignore-link' ).attr( 'href' );

            //$addToFavs.attr( 'href', addFriendLink ? addFriendLink : deleteFriendLink );
            $ignoreUser.attr( 'href', ignoreUserLink ? ignoreUserLink : removeIgnoreLink );

            $previewButton.closest( 'li' ).hide();
            $submitCancel.append( $previewClone );
            $submitCancel.find( 'input' ).hide();
        }
    };

} )( jQuery );